/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonial_David_HoefferInputs */

const en_testimonial_david_hoeffer = /** @type {(inputs: Testimonial_David_HoefferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This works surprisingly well—minimalistic app but the magic is in the background. Share PDFs to it and listen while taking a walk! Ideal for me.`)
};

const es_testimonial_david_hoeffer = /** @type {(inputs: Testimonial_David_HoefferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esto funciona sorprendentemente bien: app minimalista pero la magia está en el fondo. ¡Comparte PDFs y escucha mientras caminas! Ideal para mí.`)
};

/**
* | output |
* | --- |
* | "This works surprisingly well—minimalistic app but the magic is in the background. Share PDFs to it and listen while taking a walk! Ideal for me." |
*
* @param {Testimonial_David_HoefferInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonial_david_hoeffer = /** @type {((inputs?: Testimonial_David_HoefferInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonial_David_HoefferInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonial_david_hoeffer(inputs)
	return en_testimonial_david_hoeffer(inputs)
});